<article class="mb-8">
  <parkour-accordion
    [items]="instructions"
    [titleTemplate]="titleTemplate"
    [contentTemplate]="contentTemplate"
    [initiallyActiveItem]="initiallyActiveItem()"
  >
    <ng-template #titleTemplate let-instructie="item">
      <div>{{ instructie.title }}</div>
    </ng-template>
    <ng-template #contentTemplate let-instructie="item">
      @for (value of instructie.values; track value) {
        @if (value && value.type === 'text') {
          <div class="wysiwyg" [innerHTML]="value.text | makeReferencesAbsolute"></div>
        }
        @if (value && value.type === 'image') {
          <parkour-image [alt]="value.image!.alt || ''" [src]="value.image!.fullUrl || ''" />
        }
      }
    </ng-template>
  </parkour-accordion>
</article>
